import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12 mb-8" }
const _hoisted_2 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_3 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_4 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_5 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_6 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex min-w-0 flex-col md:col-span-3"
}
const _hoisted_8 = {
  key: 1,
  class: "flex min-w-0 flex-col md:col-span-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Đăng ký tài khoản" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Tên đăng nhập", -1)),
          _createVNode(_component_InputText, {
            id: "username",
            type: "text",
            modelValue: $setup.register.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.register.username) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[9] || (_cache[9] = _createElementVNode("label", null, "Mật khẩu(tối thiểu 6 ký tự)", -1)),
          _createVNode(_component_Password, {
            id: "password",
            modelValue: $setup.register.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.register.password) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("label", null, "Họ và tên", -1)),
          _createVNode(_component_InputText, {
            id: "fullname",
            type: "text",
            modelValue: $setup.register.fullname,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.register.fullname) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[11] || (_cache[11] = _createElementVNode("label", null, "Số điện thoại", -1)),
          _createVNode(_component_InputText, {
            id: "phoneNumber",
            type: "text",
            modelValue: $setup.register.phoneNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.register.phoneNumber) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Chọn quyền hạn", -1)),
          _createVNode(_component_Dropdown, {
            id: "permission",
            modelValue: $setup.register.permission,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.register.permission) = $event)),
            options: $setup.userPermission,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Vui lòng chọn quyền hạn của tài khoản ..."
          }, null, 8, ["modelValue", "options"])
        ]),
        ($setup.register.permission == 'ward')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "Chọn phòng", -1)),
              _createVNode(_component_Dropdown, {
                id: "permission",
                modelValue: $setup.register.idDeparment,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.register.idDeparment) = $event)),
                options: $setup.listDepartments,
                optionLabel: "name",
                optionValue: "id",
                placeholder: "Vui lòng chọn phòng ..."
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true),
        ($setup.register.permission == 'civilGroup')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[14] || (_cache[14] = _createElementVNode("label", null, "Chọn tổ", -1)),
              _createVNode(_component_Dropdown, {
                id: "civilGroup",
                modelValue: $setup.civilGroup,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.civilGroup) = $event)),
                options: $setup.listCivilGroup,
                optionLabel: "civilGroupName",
                placeholder: "Vui lòng chọn tổ ...",
                filter: true
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true)
      ]),
      ($setup.valid)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.doRegister()))
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Đăng ký",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            disabled: "disabled"
          }))
    ]),
    _: 1
  }))
}